import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { YMMetricHelper } from '@beef/metric';
var MetricClass = /*#__PURE__*/function (_YMMetricHelper) {
  function MetricClass() {
    _classCallCheck(this, MetricClass);
    return _callSuper(this, MetricClass, arguments);
  }
  _inherits(MetricClass, _YMMetricHelper);
  return _createClass(MetricClass, [{
    key: "ymPushParams",
    value: function ymPushParams(data) {
      this.sendParamsEvent(data);
    }
  }, {
    key: "ymReachGoal",
    value: function ymReachGoal(alias, params) {
      this.sendReachGoalEvent(alias, params);
    }
  }]);
}(YMMetricHelper);
var metric = new MetricClass({
  counterId: 26001372,
  isEcommerce: false,
  debug: false
});
export var ymPushParams = metric.ymPushParams.bind(metric);
export var ymReachGoal = metric.ymReachGoal.bind(metric);